export default __webpack_public_path__ + "static/media/news072604.13b6c1af.jpg";